module.exports = __webpack_public_path__ + "media/images/weather/201_day-ba3da2539485ff8d1300bb64cf3fbeb9.png";